/**
 * Validadores compartidos entre web y api.
 *
 * En Fase 3 introduciremos zod o valibot para tener validadores que
 * además generan los tipos automáticamente. De momento sólo helpers básicos.
 */

/** Comprueba que algo es un objeto plano (no null, no array). */
export function isPlainObject(v: unknown): v is Record<string, unknown> {
  return typeof v === 'object' && v !== null && !Array.isArray(v);
}
